import React from 'react';

export const Eyebrow = ({ children }) => (
  <span className="inline-block text-xs tracking-[0.3em] text-cyan-400 font-semibold uppercase mb-4">{children}</span>
);

export const SectionTitle = ({ children, accent }) => (
  <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight">
    {children} {accent && <span className="text-cyan-400">{accent}</span>}
  </h2>
);

export const GridBg = () => (
  <div className="pointer-events-none absolute inset-0 opacity-[0.07]" style={{ backgroundImage: 'linear-gradient(rgba(34,211,238,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(34,211,238,0.5) 1px, transparent 1px)', backgroundSize: '64px 64px' }} />
);

export const GlowOrb = ({ className = '' }) => (
  <div className={`pointer-events-none absolute rounded-full blur-[120px] opacity-30 bg-cyan-500 ${className}`} />
);
